const desktopHeader = document.querySelector('.site-header')
  document.querySelectorAll('[data-has-dropdowns]').forEach(function(element){
    element.addEventListener('mouseenter',function(e){
        desktopHeader.classList.add('opened') 
        e.target.querySelector('.site-nav__dropdown').style.display = "block";
        e.target.style.opacity = 1
    });
    element.addEventListener('mouseleave',function(e){
        desktopHeader.classList.remove('opened') 
        e.target.querySelector('.site-nav__dropdown').style.display = "none";
        e.target.style.opacity = ''
    });
})